// The first path segment is the merchant widget slug; it prefixes every route.
const SLUG_PATH_PREFIX = /^(\/[^/]+).*/;

export function parseBasename(pathname: string): string {
  return SLUG_PATH_PREFIX.test(pathname)
    ? pathname.replace(SLUG_PATH_PREFIX, "$1")
    : "/";
}

export function parseWidgetSlug(pathname: string): string | undefined {
  const [, slug] = pathname.split("/");
  return slug || undefined;
}
